'use strict'

var _ = require('lodash')

export function orderService (http) {
	return {
		// Load all orders
		findAll: function (filter) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'findAll',
				[filter]
			).then(function (resp) {
				return resp.result
			})
		},
		// Load all paid or cancelled orders
		findAllPaid: function (filter) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'findAll',
				[filter]
			).then(function (resp) {
				return _.filter(resp.result, (order) => {
					return (!_.isNil(order.payment) || order.orderStatus === 'X')
				})
			})
		},
		// Load orders by user id
		findOrdersByUserId: function (userId) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'findOrdersByUserId',
				[ userId ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Load order by project id
		findOrderByProjId: function (projId) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'findOrderByProjId',
				[ projId ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Load order by id
		findOrderById: function (orderId) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'findOrderById',
				[ orderId ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Add new order
		insert: function (data) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'insert',
				[ data ]
			).then(function (resp) {
				return resp.result
			})
		},
		// save order changes
		update: function (order) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'update',
				[ order ]
			).then(function (resp) {
				return resp.result
			})
		},
		// save order changes
		appendPaymentError: function (order, errorObj) {
			errorObj.date = new Date()
			order.orderStatus = 'PE'
			if (_.isNil(order.payment)) {
				order.payment = {
					error: [errorObj]
				}
			} else {
				order.payment.error.push(errorObj)
			}

			return http.jsonrpc(
				'/rpc/2.0/orders',
				'update',
				[ order ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Change status
		setStatus: function (id, status) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'setStatus',
				[ id, status ]
			).then(function (resp) {
				return resp.result
			})
		},
		// save order changes
		setPayment: function (orderId, paymentData) {
			return http.jsonrpc(
				'/rpc/2.0/orders',
				'setPayment',
				[ orderId, paymentData ]
			).then(function (resp) {
				return resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/order-service.js